import React, { useState } from 'react';

const CustomSelect = ({ options, fn_fill }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen)
    }
    const handleSelect = (option) => {
        setSelectedOption(option);
        fn_fill(option)
        setIsOpen(false);
    };

    
    return (
        <div className="custom-select">
            <div className="selected-option" onClick={toggleDropdown}>
                {selectedOption ? (
                    <div className="option-content">
                        <div className="option-icon"><img src={process.env.PUBLIC_URL + selectedOption.icon} /></div>
                        <div className="option-label">{selectedOption.label.toString().replace(/(\d{4})(?=\d)/g, '$1 ')}</div>
                    </div>
                ) : (
                    <div className='option-default'>شماره کارت فروشنده را انتخاب کنید...</div>
                )}
            </div>
            {isOpen && (
                <div className="options-list">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className="option-item"
                            onClick={() => handleSelect(option)}
                        >
                            <div className="option-icon"><img src={process.env.PUBLIC_URL + option.icon} /></div>
                            <div className="option-label">{option.label.toString().replace(/(\d{4})(?=\d)/g, '$1 ')}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;